import React from 'react'
import { Button, Modal, Table } from 'react-bootstrap'
import { Form } from 'react-bootstrap'
import { DataCalendarResponse } from '../../../services/availability-and-rates/response/DataCalendarResponse'
import useGetAllRoomType from '../../../services/room-type/hooks/useGetAllRoomType'
import FormSpinner from '../../../shared/components/spinner/FormSpinner'
import FormError from '../../../shared/components/errors/FormError'
import DateInput from '../../../shared/components/form/DateInput'

interface UnsigmentRoomModalProps {
    show: boolean
    handleClose: () => void
    unsigmentRooms: DataCalendarResponse
    setFilterDate: (date: string) => void
    filterDate: string,
    onOpen: (id: string, checkinDate: string, checkoutDate: string) => void
}

const UnsigmentRoomModal: React.FC<UnsigmentRoomModalProps> = ({
    show,
    handleClose,
    unsigmentRooms,
    setFilterDate,
    filterDate,
    onOpen
}) => {
    const { data: rooms, isSuccess, isFetching, isError } = useGetAllRoomType();

    const handleOpen = (id: string, checkinDate: string, checkoutDate: string) => {
        onOpen(id, checkinDate, checkoutDate);
        handleClose();
    }

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Unsigment Rooms</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* Filter tanggal */}
                <Form.Group className="mb-3">
                    <Form.Label>Filter by Date</Form.Label>
                    <DateInput className="form-control" value={filterDate} onChange={(e) => setFilterDate(e.target.value)} />
                </Form.Group>

                {/* Tabel daftar kamar */}
                {isError && (
                    <div className='d-flex justify-content-center'>
                        <FormError />
                    </div>
                )}
                {isFetching && (
                    <div className='d-flex justify-content-center'>
                        <FormSpinner />
                    </div>
                )}
                {isSuccess && !isFetching && (
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th>Room Type</th>
                                <th>Guest Name</th>
                                <th>Check-in Date</th>
                                <th>Check-out Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {unsigmentRooms.data.map((room) => (
                                <tr key={room.id}>
                                    <td>{rooms.data.find((value) => value.id === room.room_type_id)?.name}</td>
                                    <td>{room.customer_name}</td>
                                    <td>{room.checkin_date}</td>
                                    <td>{room.checkout_date}</td>
                                    <td>
                                        <Button variant="primary" size="sm" onClick={() => room.room_type_id && handleOpen(room.room_type_id, room.checkin_date, room.checkout_date)}>Jump to Booking</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
            </Modal.Body>
        </Modal>
    )
}

export default UnsigmentRoomModal